const sellingPlan = document.querySelector('input[name="selling_plan"]');
const inputs = document.querySelectorAll('.subscription-widget label')
let firstSellingPlanId = sellingPlan.value;

function getWidget(thisel, widget) {
    widget.preventDefault();
    if (thisel.querySelector('input').value === 'onetime') sellingPlan.value = '';
    else sellingPlan.value = firstSellingPlanId

    Array.from(inputs).forEach(input => {
        input.classList.remove('subscription-option-selected');
    })
    thisel.classList.add('subscription-option-selected');
}

function subscriptionIntervalFrequency(frq) {
    sellingPlan.value = frq.value;
    firstSellingPlanId = frq.value;
}